import React from 'react'
import clsx from 'clsx'

interface DashboardSectionDividerProps {
  className?: string
}

const DashboardSectionDivider: React.FC<DashboardSectionDividerProps> = ({ className }) => (
  <div
    role="separator"
    aria-hidden
    className={clsx('my-2 sm:my-3', className)}
  >
    <div className="h-px w-full bg-gradient-to-r from-transparent via-gray-300 to-transparent dark:via-gray-600" />
  </div>
)

export default DashboardSectionDivider
